export default{
    lang:"vi",
    fontFamily:"vi-font-family",
    fontFamilyTitle:"vi-font-family-title",
    requestLang:"en_US",
    type: "en",
}